module.exports = __webpack_public_path__ + "img/Mascota.42101cc5.svg";